import classNames from "classnames"
import { Children, cloneElement, isValidElement } from "react"
import { InputGroupContextProvider } from "./InputGroupContext"
import { InputGroupAdornment } from "./InputGroupAdornment"
import { InputGroupProps } from "./types"
import {
  WRAPPER_CLASSES,
  WRAPPER_MD_CLASSES,
  WRAPPER_SM_CLASSES,
} from "../utils/formComponentWrapperClasses"

export function InputGroup({ children, error, label = null, size = "md" }: InputGroupProps) {
  let _label = label
  const isMD = size === "md"
  const isSM = size === "sm"

  // TODO: extract to helper?
  const validChildren = Children.toArray(children).filter(isValidElement)
  const childrenCount = Children.count(children)

  // TODO: Refactor this into a util for the UI package. Check where else we are looking for displayName
  // any allows us to look at the displayName
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const _children = Children.map(validChildren, (child: any, i) => {
    if (child.type?.displayName === "TextInput") {
      const isFirst = i === 0
      const isLast = i === childrenCount - 1

      if (Object.keys(child.props).includes("label")) {
        console.warn("Please use the label prop on the InputGroup component")
      }

      // TODO: refactor this to util as it's also used in TextInput
      _label =
        label && isValidElement(label)
          ? cloneElement(label, {
              htmlFor: child.props.id || child.props.name,
              size,
              ...label.props,
            })
          : label

      return {
        ...child,
        props: {
          size,
          wrapperClassName: classNames(
            "rounded-none z-1 relative",
            {
              "rounded-l-lg": isMD && isFirst,
              "rounded-l-md": isSM && isFirst,
              "rounded-r-lg": isMD && isLast,
              "rounded-r-md": isSM && isLast,
            },
            child.props.wrapperClassName,
          ),
          ...child.props,
        },
      }
    }

    return child
  })

  return (
    <InputGroupContextProvider size={size} error={error}>
      <div
        className={classNames(WRAPPER_CLASSES, {
          [WRAPPER_SM_CLASSES]: isSM,
          [WRAPPER_MD_CLASSES]: isMD,
        })}
      >
        {_label}
        <div
          className={classNames("flex items-center", {
            "h-11": isMD,
            "h-8": isSM,
            "text-sm": isSM,
            "text-md": isMD,
          })}
        >
          {_children}
        </div>
        {error && <div className="text-sm text-error-base">{error}</div>}
      </div>
    </InputGroupContextProvider>
  )
}

InputGroup.Adornment = InputGroupAdornment
